import React, { useState } from "react";
import styled from "styled-components";

import { Button, IconButton } from "@material-ui/core";
import { AddAPhotoRounded } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { adminActions } from "../../redux/actions";

const AdminPhoto = (props) => {
	const { photo, admin_id } = props;
	// REDUX
	const dispatch = useDispatch();

	// STATE
	const [imagen, setImagen] = useState(
		photo !== false ? `data:image/png;base64, ${photo}` : ""
	);
	const [form, setForm] = useState(null);

	// FUNCTIONS
	function handlePhoto(e) {
		const reader = new FileReader();
		reader.onload = () => {
			if (reader.readyState === 2) {
				setImagen(reader.result);
			}
		};
		reader.readAsDataURL(e.target.files[0]);
		const form = new FormData();
		form.append("img", e.target.files[0]);
		setForm(form);
	}

	function handleSubmit(e) {
		e.preventDefault();
		const caracter = imagen.indexOf(",", 0);
		const newImage = imagen.substr(caracter + 1);
		dispatch(
			adminActions.photoAdminRequest({
				imagen: newImage,
				admin_id,
			})
		);
		setForm(null);
	}

	// RETURN
	return (
		<Container onSubmit={handleSubmit}>
			<PhotoWrapper>
				<Photo src={imagen} alt="logo" />
				<input
					accept="image/*"
					name="imagen"
					type="file"
					id="photoAdmin"
					hidden
					onChange={handlePhoto}
				/>
				<FakeLabel htmlFor="photoAdmin">
					<CustomIconButton color="primary" component="span">
						<AddAPhotoRounded />
					</CustomIconButton>
				</FakeLabel>
			</PhotoWrapper>
			<Button
				variant="contained"
				color="primary"
				size="small"
				type="submit"
				disabled={form === null}
				style={{ width: "max-content" }}
			>
				Guardar avatar
			</Button>
		</Container>
	);
};

export default AdminPhoto;

const Container = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	row-gap: 1rem;
`;

const PhotoWrapper = styled.div`
	position: relative;
`;

const Photo = styled.img`
	border-radius: 50%;
	width: 150px;
	height: 150px;
	max-height: 150px;
	max-width: 150px;
	object-fit: cover;
	object-position: center;
`;

const FakeLabel = styled.label`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const CustomIconButton = styled(IconButton)`
	background-color: #f6f6f6;

	&:hover {
		background-color: #f6f6f690;
	}
`;
